import { render } from "./Image_setting.vue?vue&type=template&id=15230312&scoped=true"
import script from "./Image_setting.vue?vue&type=script&lang=js"
export * from "./Image_setting.vue?vue&type=script&lang=js"

import "./Image_setting.vue?vue&type=style&index=0&id=15230312&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15230312"]])

export default __exports__